export enum ProgressStatus {
  IN_PROGRESS = 1,
  SUBMITTED = 5,
  COMPLETED = 2,
  CANCEL = 3,
  IN_REVIEW = 4,
}
